import { BILLING_REPORT } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import { appendServiceNameToURL, appendServicePortToURL } from '../resources/serviceURLs';
import UseAxios from '../http/http';

const request = (url, method = 'get', payload = null) => ({
  url,
  method,
  payload,
  headers: { 'Content-Type': 'application/json' },
  service: serviceName.PROJECT_MS,
  authRequired: true,
  csrfToken: true,
});

export const getBillingReportBaseURL = () => {
  const servicePath = appendServiceNameToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  if (process.env.NODE_ENV === 'production') return `${baseUrl}${servicePath}/api${BILLING_REPORT}`;
  return `${baseUrl}:${appendServicePortToURL(serviceName.PROJECT_MS)}${servicePath}/api${BILLING_REPORT}`;
};

export const saveBillingReport = (payload) => (
  UseAxios(request(`${BILLING_REPORT}/save`, 'post', payload))
);

export const uploadBillingReport = (payload) => (
  UseAxios(request(`${BILLING_REPORT}/upload`, 'post', payload))
);

export const deleteBillingReportRow = (billingRowId, payload) => (
  UseAxios(request(`${BILLING_REPORT}/row/${billingRowId}`, 'delete', payload))
);

export const fetchBillingReportEmployees = () => (
  UseAxios(request(`${BILLING_REPORT}/employees`))
);

export const submitBillingReport = (payload) => (
  UseAxios(request(`${BILLING_REPORT}/submit`, 'post', payload))
);

export const deleteBillingReportApprovalHistory = (historyId) => (
  UseAxios(request(`${BILLING_REPORT}/history/${historyId}`, 'delete'))
);

export const updateBillingReportApproval = (historyId, payload) => (
  UseAxios(request(`${BILLING_REPORT}/history/${historyId}`, 'put', payload))
);
